import ChatRoutes from './Chat'
import ClassRoutes from './class-and-teacher'
import OrderRoutes from './Order'
import UserRoutes from './User'
import Vue from 'vue'
import VueRouter from 'vue-router'
import authRoutes from './auth'
// import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn } from '@/auth/utils'
import reportRoutes from './Report'
import staffRoutes from './Staff'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: () => import('@/views/Home.vue'),
      meta: {
        redirectIfLoggedIn: true,
        pageTitle: 'Dashboard',
        breadcrumb: [
          {
            text: 'Dashboard',
            active: true,
          },
        ],
      },
    },
    ...ClassRoutes,
    ...OrderRoutes,
    ...ChatRoutes,
    ...UserRoutes,
    ...authRoutes,
    ...reportRoutes,
    ...staffRoutes,
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('@/views/Settings.vue'),
      meta: {
        redirectIfLoggedIn: true,
        pageTitle: 'Cài Đặt',
        breadcrumb: [
          {
            text: 'Cài Đặt Chung',
            active: true,
          },
        ],
      },
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()
  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn === null) {
    next({ name: 'login' })
  }
  return next()
})
// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
